/* tslint:disable */
import {
  RootAccount,
  IncomeInvoice
} from '../index';

declare var Object: any;
export interface ChartOfAccountInterface {
  "name": string;
  "alias": string;
  "group"?: string;
  "parent_id"?: number;
  "report_type"?: string;
  "editable"?: boolean;
  "id"?: number;
  "root_account_id"?: number;
  "createdAt": Date;
  "updatedAt": Date;
  "deletedAt"?: Date;
  rootAccount?: RootAccount;
  parentAccount?: ChartOfAccount;
  incomeInvoices?: IncomeInvoice[];
}

export class ChartOfAccount implements ChartOfAccountInterface {
  "name": string;
  "alias": string;
  "group": string;
  "parent_id": number;
  "report_type": string;
  "editable": boolean;
  "id": number;
  "root_account_id": number;
  "createdAt": Date;
  "updatedAt": Date;
  "deletedAt": Date;
  rootAccount: RootAccount;
  parentAccount: ChartOfAccount;
  incomeInvoices: IncomeInvoice[];
  constructor(data?: ChartOfAccountInterface) {
    Object.assign(this, data);
  }
  /**
   * The name of the model represented by this $resource,
   * i.e. `ChartOfAccount`.
   */
  public static getModelName() {
    return "ChartOfAccount";
  }
  /**
  * @method factory
  * @author Jonathan Casarrubias
  * @license MIT
  * This method creates an instance of ChartOfAccount for dynamic purposes.
  **/
  public static factory(data: ChartOfAccountInterface): ChartOfAccount{
    return new ChartOfAccount(data);
  }
  /**
  * @method getModelDefinition
  * @author Julien Ledun
  * @license MIT
  * This method returns an object that represents some of the model
  * definitions.
  **/
  public static getModelDefinition() {
    return {
      name: 'ChartOfAccount',
      plural: 'ChartOfAccounts',
      path: 'ChartOfAccounts',
      idName: 'id',
      properties: {
        "name": {
          name: 'name',
          type: 'string'
        },
        "alias": {
          name: 'alias',
          type: 'string'
        },
        "group": {
          name: 'group',
          type: 'string'
        },
        "parent_id": {
          name: 'parent_id',
          type: 'number'
        },
        "report_type": {
          name: 'report_type',
          type: 'string'
        },
        "editable": {
          name: 'editable',
          type: 'boolean'
        },
        "id": {
          name: 'id',
          type: 'number'
        },
        "root_account_id": {
          name: 'root_account_id',
          type: 'number'
        },
        "createdAt": {
          name: 'createdAt',
          type: 'Date'
        },
        "updatedAt": {
          name: 'updatedAt',
          type: 'Date'
        },
        "deletedAt": {
          name: 'deletedAt',
          type: 'Date',
          default: new Date(0)
        },
      },
      relations: {
        rootAccount: {
          name: 'rootAccount',
          type: 'RootAccount',
          model: 'RootAccount',
          relationType: 'belongsTo',
                  keyFrom: 'root_account_id',
          keyTo: 'id'
        },
        parentAccount: {
          name: 'parentAccount',
          type: 'ChartOfAccount',
          model: 'ChartOfAccount',
          relationType: 'belongsTo',
                  keyFrom: 'parent_id',
          keyTo: 'id'
        },
        incomeInvoices: {
          name: 'incomeInvoices',
          type: 'IncomeInvoice[]',
          model: 'IncomeInvoice',
          relationType: 'hasMany',
                  keyFrom: 'id',
          keyTo: 'chart_of_account_id'
        },
      }
    }
  }
}
